<template>
  <div
    :class="cardClass"
    :style="{ backgroundColor: `${backgroundColor}` }"
  >
    <div
      class="c-blog-card__content-container"
    >
      <div class="c-blog-card__content">
        <img
          v-if="image && image.src"
          class="c-blog-card__image u-margin-bottom-small"
          :class="centerImage ? 'u-margin-auto' : ''"
          :src="image.src"
          :alt="image.alt || image.title || 'Blog Image'"
        >

        <div
          v-if="featured && subtitleFont != 'Five Boroughs Handwriting'"
          class="c-blog-card__featured-bar u-margin-bottom-x-small"
        />

        <div
          v-if="titleLogo && titleLogo.length > 0"
          class="u-text-align-left"
        >
          <img
            class="c-blog-card--logo"
            :src="titleLogo.src"
            :alt="titleLogo.alt || 'Title Logo'"
          >
        </div>
        <div class="c-blog-card__text-wrapper">
          <h2
            v-if="title"
            :class="titleClass"
          >
            {{ truncatedTitle }}
          </h2>
          <h3
            v-if="subtitle"
            :class="subtitleClass"
            :style="{ fontFamily: subtitleFont }"
          >
            {{ subtitle }}
          </h3>
          <div
            v-if="featured && subtitleFont == 'Five Boroughs Handwriting'"
            class="c-blog-card__featured-bar u-margin-bottom-x-small"
          />
          <wysiwyg
            v-if="truncatedDescription"
            :class="wysiwygClass"
            :html="truncatedDescription"
          />
          <btn
            v-if="cta"
            v-bind="cta"
            @click="buttonClick"
          >
            {{ cta.text }}
          </btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '../button/Btn'
import Wysiwyg from '../wysiwyg/Wysiwyg'
export default {
  name: 'ContentCard',
  components: {
    Btn,
    Wysiwyg,
  },
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    textAlignment: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: ()=> ({}),
    },
    cta: {
      type: Object,
      default: null
    },
    whiteText: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleFont: {
      type: String,
      default: 'Poppins'
    },
    description: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'link',
    },
    featured: {
      type: Boolean,
      default: false,
    },
    titleLogo: {
      type: Object,
      default: ()=> ({}),
    }
  },
  computed: {
    truncatedDescription() {
      const DESCRIPTION_LENGTH = 120;
      if (this.description && this.description.length < DESCRIPTION_LENGTH){
        return this.description
      } else{
        return this.description.substring(0,DESCRIPTION_LENGTH) + '...'
      }

    },
    truncatedTitle() {
      const TITLE_LENGTH = 65;
      if (this.title && this.title.length < TITLE_LENGTH){
        return this.title
      } else{
        return this.title.substring(0,TITLE_LENGTH) + '...'
      }
    },
    cardClass() {
      if (this.textAlignment) {
        return "c-blog-card u-text-align-" + this.textAlignment;
      } else {
        return "c-blog-card u-text-align-center";
      }
    },
    centerImage(){
      if(!this.textAlignment || this.textAlignment == 'center'){
        return true;
      }
      else{ return false;}

    },
    titleClass() {
      let results = 't-heading-7 u-margin-bottom-x-small';
      if (this.featured) {
        results += ' c-blog-card__title'
      }
      if (this.whiteText) {
        results += ' t-heading-7--white'
      }
      return results;
    },
    subtitleClass() {
      let results = '';
      if (this.subtitleFont == 'Five Boroughs Handwriting') {
        results += 'c-blog-card__subtitle-boroughs u-margin-bottom-small'
      } else {
        results += 't-heading-5 u-margin-bottom-xx-small'
      }
      if (this.featured) {
        results += ' c-blog-card__subtitle'
      }
      if (this.whiteText) {
        results += ' t-heading-5--white'
      }
      return results;
    },
    wysiwygClass() {
      let wysiwygClass = '';
      if (this.cta) {
        wysiwygClass += " u-margin-bottom-medium";
      }
      if (this.featured) {
        wysiwygClass += " c-blog-card__description";
      }
      if (this.whiteText) {
        wysiwygClass += " u-foreground-white";
      }
      return wysiwygClass;
    }
  },
  methods: {
    buttonClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-blog-card {
  box-shadow:0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;
  //height:rem(520px);
  border-radius: rem(10px);
  padding-bottom:rem(20px);
  max-width: rem(600px);
  &__text-wrapper {
    padding: 0 rem(20px)
  }
  &__description {
    max-width: 220px;
    margin: 0 auto;
  }
  &__image {
    width: 100%;
    display:block;
    max-height: rem(300px);
    border-radius: rem(10px) rem(10px) 0 0;
  }

  &__subtitle {
    max-width: rem(350px);
  }

  &__subtitle-boroughs {
    font-size: rem(80px);
    letter-spacing: rem(0.8px);
    line-height: rem(50px);
    text-transform: lowercase;
    font-weight: $font-weight-book;
    max-width: 100%;
  }

  &__description {
    max-width: rem(450px);
  }
  &__featured-bar {
    width: 42px;
    height: 7px;
    @include themify($themes) {
      background-color: themed('accent', 'light')
    }
  }
  &--logo {
    max-height: rem(50px);
  }
}
</style>
